export default __webpack_public_path__ + "7150dbfa6d5a15d1753cfcae06d91baa.png";